var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"partner-card-wrapper px-4 py-4 mb-4",attrs:{"to":{
		name: 'exhibitor-by-id',
		params: {
			id: _vm.partner.partner_id
		}
	}}},[_c('img',{staticClass:"partner-card-logo",attrs:{"src":_vm.partner.partner_logo,"alt":"partnerLogo","loading":"lazy"}}),_c('div',[_c('div',{staticClass:"partner-card-title"},[_vm._v(" "+_vm._s(_vm.partner.partner_name)+" ")]),_c('div',{staticClass:"partner-card-description"},[_vm._v(" "+_vm._s(_vm.partner.partner_brief_description)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }